import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EventCard } from '@/components/events/EventCard';
import { useEvents } from '@/hooks/useEvents';
import { useProfile } from '@/hooks/useProfile';
import { Loader2, Calendar, Globe, MapPin } from 'lucide-react';
import { CreateEventDialog } from '@/components/events/CreateEventDialog';

export default function EventsPage() {
  const { data: profile } = useProfile();
  const localCohort = profile?.city_cohort || 'Sydney';
  const [activeTab, setActiveTab] = useState(localCohort);
  
  const { data: events, isLoading, isError, error } = useEvents(
    activeTab === 'all' ? undefined : activeTab
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-display font-bold text-foreground">Events</h1>
          <p className="text-muted-foreground text-sm">
            Small, intentional gatherings
          </p>
        </div>
        <CreateEventDialog />
      </div>

      {/* Event Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="w-full grid grid-cols-2 mb-4">
          <TabsTrigger value={localCohort} className="gap-2">
            <MapPin className="h-4 w-4" />
            {localCohort}
          </TabsTrigger>
          <TabsTrigger value="all" className="gap-2">
            <Globe className="h-4 w-4" />
            All Events
          </TabsTrigger>
        </TabsList>

        <TabsContent value={activeTab} className="space-y-4 mt-0">
          {isLoading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          ) : isError ? (
            <div className="text-center py-12">
              <p className="text-sm text-destructive">
                {error instanceof Error ? error.message : 'Unable to load events.'}
              </p>
            </div>
          ) : events && events.length > 0 ? (
            <div className="space-y-4">
              {events.map((event) => (
                <EventCard key={event.id} event={event} />
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <Calendar className="h-12 w-12 text-muted-foreground/50 mx-auto mb-4" />
              <p className="text-muted-foreground">
                No upcoming events. Check back soon!
              </p>
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
